<template>
  <div style="height: 85vh" class="mr-16 pr-16">
    <div v-if="watermark_dynamic" class="watermark">{{ currentUser.name }}</div>
    <img class="watermark" v-else :src="watermark_url"/>

    <!--  BROADCASTER NOT IN CHANNEL ERROR  -->
    <div class="fullscreen_center_box_absolute"
         :style="{display: broadcasterIsInChannel === false ? '' : 'none'}">
      <v-alert
          :color="colors.danger"
          type="warning"
      >
        <span>
          استاد در جلسه حضور ندارد
        <v-btn color="warning"
               @click="closeMeeting"
               class="white--text ml-1">
                <v-icon>mdi-exit-to-app</v-icon>
        </v-btn>
        </span>
      </v-alert>
    </div>

    <!--  LOADING  -->
    <div v-if="loading" class="fullscreen_center_box">
      <v-progress-circular
          :size="70"
          :width="7"
          color="purple"
          indeterminate
      ></v-progress-circular>
    </div>

    <!--  ERRORS  -->
    <div v-else-if="errors.length" class="fullscreen_center_box">
      <v-alert
          :color="colors.danger"
          type="warning"
      >
        <span v-for="(error, index) in errors" :key="index">
          {{ error }}
          <br>
        </span>
      </v-alert>
    </div>

    <!--  MAIN VIDEOS  -->
    <v-row v-else class="pa-10">
      <!-- WHITEBOARD-->
      <v-col v-if="whiteBoardStatus && broadcasterIsInChannel && !loading && !errors.length" cols="12"
             style="height: 400px">
        <meeting-whiteboard-desktop :colors="colors"></meeting-whiteboard-desktop>
      </v-col>

      <!--  SELF VIDEO  -->
      <v-col cols="12" xl="3" lg="4" md="6" sm="12" xs="12">
        <meeting-self-card-desktop id="self-card"
                                   ref="selfCard"
                                   reff="self"
                                   @toggleFullScreen="toggleFullScreen"
                                   @toggleMuteAudio="toggleMuteAudio"
                                   @toggleMuteVideo="toggleMuteVideo"
                                   @toggleShareScreen="toggleShareScreen"
                                   @toggleWhiteBoard="toggleWhiteBoard"
                                   @selectVideo="selectVideo"
                                   @videoFileSelected="videoFileSelected"
                                   @selectAudio="selectAudio"
                                   @audioFileSelected="audioFileSelected"
                                   @toggleRecord="toggleRecord"
                                   @giveMePermission="giveMePermission"
                                   :mutedAudio="mutedAudio"
                                   :mutedVideo="mutedVideo"
                                   :screenIsSharing="screenIsSharing"
                                   :microphonePermission="microphonePermission"
                                   :webcamPermission="webcamPermission"
                                   :screenPermission="screenPermission"
                                   :whiteboardPermission="whiteboardPermission"
                                   :whiteBoardStatus="whiteBoardStatus"
                                   :videoPermission="videoPermission"
                                   :videoFileIsSharing="videoFileIsSharing"
                                   :audioPermission="audioPermission"
                                   :audioFileIsSharing="audioFileIsSharing"
                                   :recordPermission="recordPermission"
                                   :isRecording="isRecording"
                                   :recordIcon="recordIcon"
                                   :currentUser="currentUser"
                                   :colors="colors">
        </meeting-self-card-desktop>
      </v-col>
      <!--  OTHER USERS VIDEOS  -->
      <v-col cols="12" xl="3" lg="4" md="6" sm="12" xs="12" v-for="user in users" :key="user.id">
        <meeting-simple-card-desktop @toggleFullScreen="toggleFullScreen"
                                     :mirror="true"
                                     mode="video"
                                     :playsinline="true"
                                     :autoplay="true"
                                     :controls="false"
                                     :muted="false"
                                     :id="'user-video-card-' + user.id"
                                     :ref="'card-v' + user.id"
                                     :reff="'v' + user.id"
                                     :user="user"
                                     :colors="colors"
                                     :selfChip="false"
                                     :chipText="user.isBroadcaster ? 'استاد : ' + user.name : user.name">
        </meeting-simple-card-desktop>
      </v-col>

      <!--  SELF SCREEN  -->
      <v-col cols="12" xl="3" lg="4" md="6" sm="12" xs="12" :style="{display: screenIsSharing ? '' : 'none'}">
        <meeting-simple-card-desktop @toggleFullScreen="toggleFullScreen"
                                     :mirror="false"
                                     mode="video"
                                     :playsinline="true"
                                     :autoplay="true"
                                     :controls="false"
                                     :muted="true"
                                     id="screen-card"
                                     ref="screenCard"
                                     reff="screen"
                                     :selfChip="true"
                                     :chipText="'صفحه شما'"
                                     :colors="colors">
        </meeting-simple-card-desktop>
      </v-col>
      <!--  OTHER USERS SCREENS  -->
      <v-col cols="12" xl="3" lg="4" md="6" sm="12" xs="12" v-for="screen in screens" :key="screen.ref">
        <meeting-simple-card-desktop @toggleFullScreen="toggleFullScreen"
                                     :mirror="false"
                                     mode="video"
                                     :playsinline="true"
                                     :autoplay="true"
                                     :controls="false"
                                     :muted="false"
                                     :id="'screen-card-user-' + screen.ref"
                                     :ref="'screenCard-' + screen.ref"
                                     :reff="screen.ref"
                                     :selfChip="false"
                                     :chipText="'صفحه ی ' + screen.user.name"
                                     :colors="colors">
        </meeting-simple-card-desktop>
      </v-col>

      <!--  OTHER USERS WHITEBOARD  -->
      <v-col cols="12" xl="3" lg="4" md="6" sm="12" xs="12" v-for="whiteboard in whiteboards" :key="whiteboard.ref">
        <meeting-simple-card-desktop @toggleFullScreen="toggleFullScreen"
                                     :mirror="false"
                                     mode="video"
                                     :playsinline="true"
                                     :autoplay="true"
                                     :controls="false"
                                     :muted="true"
                                     :id="'whiteboard-card-user-' + whiteboard.ref"
                                     :ref="'whiteboardCard-' + whiteboard.ref"
                                     :reff="whiteboard.ref"
                                     :selfChip="false"
                                     :chipText="'صفحه ی ' + whiteboard.user.name"
                                     :colors="colors">
        </meeting-simple-card-desktop>
      </v-col>

      <!--  Video File  -->
      <v-col cols="12" xl="3" lg="4" md="6" sm="12" xs="12" v-if="videoFileIsSharing">
        <meeting-simple-card-desktop @toggleFullScreen="toggleFullScreen"
                                     @cancelFileSharing="cancelVideoSharing"
                                     :mirror="false"
                                     mode="video"
                                     :playsinline="false"
                                     :autoplay="videoFileSharer.id != currentUser.id"
                                     :controls="videoFileSharer.id == currentUser.id"
                                     :muted="false"
                                     id="shared-video-file"
                                     ref="videoFileCard"
                                     reff="video-file"
                                     :selfChip="false"
                                     :chipText="videoFileSharer.name + ' یک فایل به اشتراک گذاشت'"
                                     :currentUser="currentUser"
                                     :fileSharer="videoFileSharer"
                                     :colors="colors">
        </meeting-simple-card-desktop>
      </v-col>

      <!--  Audio File  -->
      <v-col cols="12" xl="3" lg="4" md="6" sm="12" xs="12" v-if="audioFileIsSharing">
        <meeting-simple-card-desktop @toggleFullScreen="toggleFullScreen"
                                     @cancelFileSharing="cancelAudioSharing"
                                     :mirror="false"
                                     mode="audio"
                                     :autoplay="audioFileSharer.id != currentUser.id"
                                     :controls="audioFileSharer.id == currentUser.id"
                                     id="shared-audio-file"
                                     ref="audioFileCard"
                                     reff="audio-file"
                                     :chipText="audioFileSharer.name + ' یک فایل به اشتراک گذاشت'"
                                     :currentUser="currentUser"
                                     :fileSharer="audioFileSharer"
                                     :colors="colors">
        </meeting-simple-card-desktop>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <meeting-comment-desktop v-if="!loading && broadcasterIsInChannel"
                                 :currentUser="currentUser"
                                 :meetingId="meeting_id"
                                 :echo="Echo"
                                 :colors="colors"
                                 :currentUserIsAdmin="currentUserIsAdmin"
        ></meeting-comment-desktop>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="bottom-buttons-group">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn fab rounded :color="colors.danger" v-bind="attrs" v-on="on"
                     @click="closeMeeting"
                     class="white--text ml-1">
                <v-icon>mdi-exit-to-app</v-icon>
              </v-btn>
            </template>
            <span>خروج</span>
          </v-tooltip>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {getPermissions} from "@/helpers";
import Peer from "simple-peer";
import Echo from "laravel-echo";
import MeetingSelfCardDesktop from "../../../../../components/Components/Desktop/Meeting/MeetingSelfCardDesktop";
import MeetingSimpleCardDesktop from "../../../../../components/Components/Desktop/Meeting/MeetingSimpleCardDesktop";
import MeetingCommentDesktop from "../../../../../components/Components/Desktop/Meeting/MeetingCommentDesktop";
import MeetingWhiteboardDesktop from "../../../../../components/Components/Desktop/Meeting/MeetingWhiteboardDesktop";

export default {
  name: "MeetingDesktop",
  components: {MeetingWhiteboardDesktop, MeetingSimpleCardDesktop, MeetingSelfCardDesktop, MeetingCommentDesktop},
  data() {
    return {
      /* Page Config */
      loading: true,
      errors: [],

      /* Instances */
      Echo: null,
      webSocketChannel: null,

      /* Turn Credentials */
      turn_url: "turn:185.8.174.32:3478",
      turn_username: 'vod',
      turn_credential: '0520',

      /* General Data */
      meeting_id: null,
      broadcaster_id: null,
      broadcasterIsInChannel: true,
      watermark_dynamic: null,
      watermark_url: null,
      whiteBoardStatus: false,
      currentUserIsAdmin: false,

      /* Users */
      users: [],
      currentUser: {},

      /* Peer Connections */
      peers: {},
      screens: [],
      whiteboards: [],

      /* Permissions */
      microphonePermission: null,
      webcamPermission: null,
      screenPermission: null,
      whiteboardPermission: null,
      videoPermission: null,
      audioPermission: null,
      recordPermission: null,

      /* General Config */
      mutedAudio: false,
      mutedVideo: false,
      fullscreenElement: null,

      /* Screen Config */
      screenIsSharing: false,

      /* Video File Config*/
      videoFileIsSharing: false,
      videoFileSharer: null,

      /* Audio File Config */
      audioFileIsSharing: false,
      audioFileSharer: null,

      /* Recorder Config */
      isRecording: false,
      recordInterval: null,
      recordIcon: 1,
      mediaRecorder: null,

      /* Theme */
      colors: {
        success: '#4caf50',
        warning: '#fb8c00',
        danger: '#f44336',
      }
    }
  },

  mounted() {
    window.addEventListener("resize", this.handlePageResize);

    let meetingID = this.$route.params.meeting_id
    let instructorID = this.$route.params.instructor_id

    window.axios.post('/session/online-class/student/join', {
      meeting_id: meetingID,
      instructor_id: instructorID,
    }).then((res) => {
      this.watermark_dynamic = res.data.data.watermark_dynamic
      this.watermark_url = res.data.data.watermark_url
      this.meeting_id = res.data.data.meeting_id
      this.broadcaster_id = res.data.data.broadcaster_id
      this.currentUser.id = res.data.data.user_id
      if (this.broadcaster_id == this.currentUser.id) {
        this.broadcasterIsInChannel = true
        this.currentUser.isBroadcaster = true
      }
      this.currentUserIsAdmin = res.data.data.currentUserIsAdmin
      this.currentUser.name = res.data.data.user_name

      this.microphonePermission = res.data.data.permissions.microphone
      this.webcamPermission = res.data.data.permissions.webcam
      this.screenPermission = res.data.data.permissions.screen
      this.whiteboardPermission = res.data.data.permissions.whiteboard
      this.videoPermission = res.data.data.permissions.video
      this.audioPermission = res.data.data.permissions.audio
      this.recordPermission = res.data.data.permissions.record

      this.loading = false

      this.initialMeeting()
    }).catch((err) => {
      console.log('Err Joining Class : ', err)
      this.errors.push(err.response.data.message)
      this.loading = false
    })
  },

  methods: {
    giveMePermission() {
      window.axios.post('/session/online-class/student/hand', {
        instructor_id: this.broadcaster_id
      }).then((res) => {
        console.log(res)
      })
    },
    closeMeeting() {
      Object.entries(this.peers).forEach((peer) => {
        peer[1].getPeer().destroy();
      })
      this.Echo.leave("meeting." + this.meeting_id)
      this.Echo.leave(`meeting.user.${this.currentUser.id}`)
      this.errors = []
      this.showScore = true
      this.$router.push('/dashboard/online-sessions')
    },
    async initialMeeting() {
      /* INITIAL ECHO INSTANCE */
      this.Echo = new Echo({
        broadcaster: 'pusher',
        key: 'myKey',
        cluster: 'mt1',
        wsHost: process.env.VUE_APP_WS_HOST,
        wsPort: process.env.VUE_APP_WS_PORT,
        forceTLS: process.env.VUE_APP_FORCE_TLS !== 'false',
        disableStats: true,
        encrypted: true,
        auth: {
          headers: {
            Authorization: 'Bearer ' + this.$cookies.get('token')
          }
        },
        authorizer: (channel) => {
          return {
            authorize: (socketId, callback) => {
              window.mainAxios.post('/api/students/broadcasting/auth', {
                socket_id: socketId,
                channel_name: channel.name
              }, {
                headers: {
                  Authorization: this.$cookies.get('token')
                }
              })
                  .then(response => {
                    callback(false, response.data);
                  })
                  .catch(error => {
                    callback(true, error);
                  });
            }
          };
        },
      });

      this.$nextTick(async () => {
        /* GET USER AUDIO AND VIDEO */
        this.$refs.selfCard.$refs.self.srcObject = await getPermissions(true, true);
        if (!this.webcamPermission) {
          this.toggleMuteVideo()
        }
        if (!this.microphonePermission) {
          this.toggleMuteAudio()
        }

        /* JOIN MAIN STREAM CHANNEL */
        this.webSocketChannel = this.Echo.join("meeting." + this.meeting_id);

        /* RUN WHEN USER JOIN CHANNEL */
        this.webSocketChannel.here((users) => {
          console.log(users, 'first users')
          users.forEach((user) => {
            if (this.broadcaster_id == user.id) {
              user.isBroadcaster = true
              this.broadcasterIsInChannel = true
              if (this.currentUser.id === user.id) {
                this.currentUser.isBroadcaster = true
              }
            }
            console.log(this.currentUser, 'currentUser')
            if (this.currentUser.id != user.id) {
              this.users.push(user)
              this.$set(
                  this.peers,
                  `${user.id}`,
                  this.peerCreator(
                      this.$refs.selfCard.$refs.self.srcObject,
                      user,
                  )
              );
              this.peers[user.id].create();
              this.peers[user.id].initEvents();
            }
          })
          if (this.broadcasterIsInChannel === null) {
            this.broadcasterIsInChannel = true
          }
        })

        /* RUN WHEN NEW USER JOIN CHANNEL ON OTHER USERS DEVICE */
        this.webSocketChannel.joining((user) => {
          user.isBroadcaster = this.broadcaster_id == user.id;
          if (this.broadcaster_id == user.id) {
            user.isBroadcaster = true
            this.broadcasterIsInChannel = true
            if (this.currentUser.id === user.id) {
              this.currentUser.isBroadcaster = true
            }
          }
          this.users.push(user)
          this.$set(
              this.peers,
              `${user.id}`,
              this.peerCreator(
                  this.$refs.selfCard.$refs.self.srcObject,
                  user,
              )
          );
          this.peers[user.id].create();
          this.peers[user.id].initEvents();

          if (this.screenIsSharing) {
            this.$set(
                this.peers,
                `screen-${user.id}`,
                this.peerCreator(
                    this.$refs.screenCard.$refs.screen.srcObject,
                    user,
                    true,
                )
            );
            this.peers[`screen-${user.id}`].create();
            this.peers[`screen-${user.id}`].initEvents();
          }

          if (this.whiteBoardStatus) {
            this.$set(
                this.peers,
                `whiteboard-${user.id}`,
                this.peerCreator(
                    document.getElementById('canvas').captureStream(),
                    user,
                    false, true,
                )
            );
            this.peers[`whiteboard-${user.id}`].create();
            this.peers[`whiteboard-${user.id}`].initEvents();
          }

          if (this.videoFileIsSharing) {
            let videoEl = this.$refs["videoFileCard"].$refs["video-file"];
            let localVideoStream = null
            if (typeof videoEl.mozCaptureStream == 'function') {
              localVideoStream = videoEl.mozCaptureStream();
            } else {
              localVideoStream = videoEl.captureStream();
            }

            this.$set(
                this.peers,
                `video-file-share-${user.id}`,
                this.peerCreator(
                    localVideoStream,
                    user, false, false, true
                )
            );
            this.peers[`video-file-share-${user.id}`].create();
            this.peers[`video-file-share-${user.id}`].initEvents();
          }

          if (this.audioFileIsSharing) {
            let audioEl = this.$refs["audioFileCard"].$refs["audio-file"];
            let localAudioStream = null
            if (typeof audioEl.mozCaptureStream == 'function') {
              localAudioStream = audioEl.mozCaptureStream();
            } else {
              localAudioStream = audioEl.captureStream();
            }

            this.$set(
                this.peers,
                `audio-file-share-${user.id}`,
                this.peerCreator(
                    localAudioStream,
                    user, false, false, false, true
                )
            );
            this.peers[`audio-file-share-${user.id}`].create();
            this.peers[`audio-file-share-${user.id}`].initEvents();
          }
        })

        /* RUN WHEN USER LEAVE CHANNEL ON OTHER USERS DEVICE */
        this.webSocketChannel.leaving((user) => {
          this.peers[user.id].getPeer().destroy();
          if (this.broadcaster_id == user.id) {
            this.broadcasterIsInChannel = true
          }
          delete this.peers[user.id];
          if (user.id == this.currentUser.id) {
            this.users = [];
          } else {
            const leavingUserIndex = this.users.findIndex(
                (data) => data.id === user.id
            );
            this.users.splice(leavingUserIndex, 1);
          }
        });

        /* ANSWER OF OFFER LISTENER. THIS WOULD FINALIZE PEER CONNECTION */
        this.Echo.private(`meetingUser.${this.currentUser.id}`).listen(
            ".Answer",
            ({data}) => {
              console.log('Answer')
              if (data.answer.sdp) {
                const updatedSignal = {
                  ...data.answer,
                  sdp: `${data.answer.sdp}\n`,
                };
                if (data.screen) {
                  this.peers['screen-' + data.receiver.id]
                      .getPeer()
                      .signal(updatedSignal);
                } else if (data.whiteboard) {
                  this.peers['whiteboard-' + data.receiver.id]
                      .getPeer()
                      .signal(updatedSignal);
                } else if (data.videoFile) {
                  this.peers['video-file-share-' + data.receiver.id]
                      .getPeer()
                      .signal(updatedSignal);
                } else if (data.audioFile) {
                  this.peers['audio-file-share-' + data.receiver.id]
                      .getPeer()
                      .signal(updatedSignal);
                } else {
                  this.peers[data.receiver.id]
                      .getPeer()
                      .signal(updatedSignal);
                }
              }
            }
        );

        /* LISTEN FOR SIGNAL OFFER FROM BROADCASTERS */
        this.Echo.private(`meetingUser.${this.currentUser.id}`).listen(
            ".Offer",
            ({data}) => {
              console.log('Offer')
              this.createViewerPeer(data.sharer, data.offer, data.broadcaster,
                  data.screen, data.whiteboard, data.videoFile, data.audioFile);
            }
        );

        /* LISTEN FOR END MEETING EVENT */
        this.Echo.private(`meeting.${this.meeting_id}`).listen(
            "MeetingEnded",
            () => {
              this.showScore = true
            }
        );

        /* LISTEN FOR MEETING PERMISSION  UPDATING*/
        this.Echo.private(`meetingUser.${this.currentUser.id}`).listen(
            ".PermissionsUpdated",
            async ({data}) => {
              this.microphonePermission = data.microphone
              this.webcamPermission = data.webcam
              this.screenPermission = data.screen
              this.whiteboardPermission = data.whiteboard
              this.videoPermission = data.video
              this.audioPermission = data.audio
              this.recordPermission = data.record
              if (this.isRecording && !this.recordPermission) {
                await this.toggleRecord()
              }
              if (this.audioFileIsSharing && !this.audioPermission) {
                this.cancelAudioSharing()
              }
              if (this.videoFileIsSharing && !this.videoPermission) {
                this.cancelVideoSharing()
              }
              if (this.screenIsSharing && !this.screenPermission) {
                await this.toggleShareScreen()
              }
              if (this.whiteBoardStatus && !this.whiteboardPermission) {
                this.toggleWhiteBoard()
              }
              if (!this.mutedVideo && !this.webcamPermission) {
                this.toggleMuteVideo()
              }
              if (!this.mutedAudio && !this.microphonePermission) {
                this.toggleMuteAudio()
              }
            }
        );
      })
    },

    /* CREATE NEW PEER CONNECTION TO SHARE STREAM WITH SPECIFIC USER */
    peerCreator(stream, user, screen = false, whiteboard = false, videoFile = false, audioFile = false) {
      let peer;
      return {
        create: () => {
          peer = new Peer({
            initiator: true,
            trickle: false,
            stream: stream,
            config: {
              iceServers: [
                {
                  urls: "stun:stun.stunprotocol.org",
                },
                {
                  urls: this.turn_url,
                  username: this.turn_username,
                  credential: this.turn_credential,
                },
              ],
            },
          });
        },
        getPeer: () => peer,
        initEvents: () => {
          /* CALL OFFER API TO SEND OFFER TO OTHER PEER VIA WEBSOCKET */
          peer.on("signal", (offer) => {
            window.axios.post("/session/online-class/student/offer", {
              sharer: this.currentUser,
              receiverId: user.id,
              offer,
              screen,
              whiteboard,
              videoFile,
              audioFile
            })
                .then(() => {
                })
                .catch((err) => {
                  console.log('Err Offer : ', err);
                });
          });
          peer.on("stream", (/*stream*/) => {
          });
          peer.on("track", (/*track, stream*/) => {
          });
          peer.on("connect", () => {
          });
          peer.on("close", () => {
          });
          peer.on("error", (err) => {
            console.log('Err peerCreator : ', err)
          });
        },
      };
    },

    /* CREATE VIEWER PEER TO RECEIVE STREAMS FROM OTHER PEER */
    createViewerPeer(sharer, incomingOffer, broadcaster, screen = false, whiteboard = false, videoFile = false, audioFile = false) {
      const peer = new Peer({
        initiator: false,
        trickle: false,
        config: {
          iceServers: [
            {
              urls: "stun:stun.stunprotocol.org",
            },
            {
              urls: this.turn_url,
              username: this.turn_username,
              credential: this.turn_credential,
            },
          ],
        },
      });
      peer.addTransceiver("video", {direction: "recvonly"});
      peer.addTransceiver("audio", {direction: "recvonly"});

      /* CALL ANSWER API TO SEND ANSWER OF OFFER TO OTHER PEER VIA WEBSOCKET */
      peer.on("signal", (data) => {
        window.axios.post("/session/online-class/student/answer", {
          broadcasterId: broadcaster.id,
          answer: data,
          screen, whiteboard, videoFile, audioFile
        })
            .then((/*res*/) => {
            })
            .catch((err) => {
              console.log('Err Answer : ', err);
            });
      });
      peer.on("stream", (stream) => {

        if (screen) {
          /* HANDLE SCREEN SHARING */
          this.screens.push({
            ref: 'screen' + broadcaster.id,
            user: broadcaster
          })
          this.$nextTick(() => {
            this.$refs['screenCard-screen' + broadcaster.id][0].$refs['screen' + broadcaster.id].srcObject = stream;
          })

        } else if (whiteboard) {
          /* HANDLE WHITEBOARD */
          this.whiteboards.push({
            ref: 'whiteboard' + broadcaster.id,
            user: broadcaster
          })
          this.$nextTick(() => {
            this.$refs['whiteboardCard-whiteboard' + broadcaster.id][0].$refs['whiteboard' + broadcaster.id].srcObject = stream;
          })

        } else if (videoFile) {
          /* HANDLE VIDEO FILE SHARING */
          this.videoFileIsSharing = true
          this.videoFileSharer = sharer
          this.$nextTick(() => {
            this.$refs["videoFileCard"].$refs["video-file"].srcObject = stream
          })

        } else if (audioFile) {
          /* HANDLE AUDIO FILE SHARING */
          this.audioFileIsSharing = true
          this.audioFileSharer = sharer
          this.$nextTick(() => {
            this.$refs["audioFileCard"].$refs["audio-file"].srcObject = stream
          })

        } else {
          /* HANDLE NORMAL STREAM */
          this.$refs['card-v' + broadcaster.id][0].$refs['v' + broadcaster.id].srcObject = stream;
        }
      });
      peer.on("track", (/*track, stream*/) => {
      });
      peer.on("connect", () => {
      });
      peer.on("close", () => {
        /* REMOVE SCREEN */
        if (screen) {
          const leavingScreenIndex = this.screens.findIndex(
              (data) => data.ref === 'screen' + broadcaster.id
          );
          this.screens.splice(leavingScreenIndex, 1);
        }
        /* REMOVE WHITEBOARD */
        if (whiteboard) {
          const leavingWhiteboardIndex = this.whiteboards.findIndex(
              (data) => data.ref === 'whiteboard' + broadcaster.id
          );
          this.whiteboards.splice(leavingWhiteboardIndex, 1);
        }
        /* REMOVE VIDEO FILE */
        if (videoFile) {
          this.videoFileIsSharing = false
          this.videoFileSharer = null
        }
        /* REMOVE AUDIO FILE */
        if (audioFile) {
          this.audioFileIsSharing = false
          this.audioFileSharer = null
        }
        peer.destroy();
      });
      peer.on("error", (err) => {
        console.log('Err createViewerPeer : ', err)
      });
      const updatedOffer = {
        ...incomingOffer,
        sdp: `${incomingOffer.sdp}\n`,
      };
      peer.signal(updatedOffer);
    },

    toggleMuteAudio() {
      if (this.mutedAudio) {
        this.$refs.selfCard.$refs.self.srcObject.getAudioTracks()[0].enabled = true;
        this.mutedAudio = false;
      } else {
        this.$refs.selfCard.$refs.self.srcObject.getAudioTracks()[0].enabled = false;
        this.mutedAudio = true;
      }
    },

    toggleMuteVideo() {
      if (this.mutedVideo) {
        this.$refs.selfCard.$refs.self.srcObject.getVideoTracks()[0].enabled = true;
        this.mutedVideo = false;
      } else {
        this.$refs.selfCard.$refs.self.srcObject.getVideoTracks()[0].enabled = false;
        this.mutedVideo = true;
        this.mutedScreen = true;
      }
    },

    async toggleShareScreen() {
      if (this.screenIsSharing) {
        this.users.forEach((user) => {
          this.peers[`screen-${user.id}`].getPeer().destroy();
          delete this.peers[`screen-${user.id}`];
        })
        this.screenIsSharing = false
        this.$refs.screenCard.$refs.screen.srcObject = null
      } else {
        await navigator.mediaDevices.getDisplayMedia({
          audio: {
            echoCancellation: true,
            noiseSuppression: true,
            sampleRate: 44100
          }, video: true
        }).then(stream => {
          this.screenIsSharing = true
          this.$refs.screenCard.$refs.screen.srcObject = stream

          this.users.forEach((user) => {
            this.$set(
                this.peers,
                `screen-${user.id}`,
                this.peerCreator(
                    this.$refs.screenCard.$refs.screen.srcObject,
                    user,
                    true,
                )
            );
            this.peers[`screen-${user.id}`].create();
            this.peers[`screen-${user.id}`].initEvents();
          })
        })
      }
    },

    toggleWhiteBoard() {
      if (this.whiteBoardStatus) {
        this.users.forEach((user) => {
          this.peers[`whiteboard-${user.id}`].getPeer().destroy();
          delete this.peers[`whiteboard-${user.id}`];
        })
        this.whiteBoardStatus = false
      } else {
        this.whiteBoardStatus = true

        let self = this
        setTimeout(() => {
          self.users.forEach((user) => {
            self.$set(
                self.peers,
                `whiteboard-${user.id}`,
                self.peerCreator(
                    document.getElementById('canvas').captureStream(),
                    user, false, true,
                )
            );
            self.peers[`whiteboard-${user.id}`].create();
            self.peers[`whiteboard-${user.id}`].initEvents();
          })
        }, 1000)
      }
    },

    selectVideo() {
      let elem = document.getElementById('video-file-input');
      let evt = document.createEvent("MouseEvents");
      evt.initEvent("click", true, false);
      elem.dispatchEvent(evt);
    },
    videoFileSelected() {
      this.videoFileIsSharing = true
      this.videoFileSharer = this.currentUser
      this.$nextTick(() => {
        let videoEl = this.$refs["videoFileCard"].$refs["video-file"];
        let file = document.getElementById('video-file-input').files[0];
        let type = file.type;
        if (!videoEl.canPlayType(type)) {
          alert('cannot play that file');
          return;
        }
        videoEl.src = URL.createObjectURL(file);
        videoEl.play().then(() => {
          // Mozilla currently prefixes the function name, so we have to check for either
          let localVideoStream = null
          if (typeof videoEl.mozCaptureStream == 'function') {
            localVideoStream = videoEl.mozCaptureStream();
            // Mozilla mozCaptureStream function has a bug which will destroy sound from the original videoEl so we
            // have to play it manually
            const ctx = new AudioContext();
            const dest = ctx.createMediaStreamSource(localVideoStream);
            dest.connect(ctx.destination);
          } else {
            localVideoStream = videoEl.captureStream();
          }

          if (localVideoStream) {
            this.users.forEach((user) => {
              this.$set(
                  this.peers,
                  `video-file-share-${user.id}`,
                  this.peerCreator(
                      localVideoStream,
                      user, false, false, true
                  )
              );
              this.peers[`video-file-share-${user.id}`].create();
              this.peers[`video-file-share-${user.id}`].initEvents();
            })
          }
        });
      })
    },
    cancelVideoSharing() {
      this.users.forEach((user) => {
        this.peers[`video-file-share-${user.id}`].getPeer().destroy();
        delete this.peers[`video-file-share-${user.id}`];
      })
      this.videoFileIsSharing = false
      this.videoFileSharer = null
      this.$refs["videoFileCard"].$refs["video-file"].srcObject = null
    },

    selectAudio() {
      let elem = document.getElementById('audio-file-input');
      let evt = document.createEvent("MouseEvents");
      evt.initEvent("click", true, false);
      elem.dispatchEvent(evt);
    },
    audioFileSelected() {
      this.audioFileIsSharing = true
      this.audioFileSharer = this.currentUser
      this.$nextTick(() => {
        let audioEl = this.$refs["audioFileCard"].$refs["audio-file"];
        let file = document.getElementById('audio-file-input').files[0];
        let type = file.type;
        if (!audioEl.canPlayType(type)) {
          alert('cannot play that file');
          return;
        }
        audioEl.src = URL.createObjectURL(file);
        audioEl.play().then(() => {
          // Mozilla currently prefixes the function name, so we have to check for either
          let localAudioStream = null
          if (typeof audioEl.mozCaptureStream == 'function') {
            localAudioStream = audioEl.mozCaptureStream();
            // Mozilla mozCaptureStream function has a bug which will destroy sound from the original audioEl so we
            // have to play it manually
            const ctx = new AudioContext();
            const dest = ctx.createMediaStreamSource(localAudioStream);
            dest.connect(ctx.destination);
          } else {
            localAudioStream = audioEl.captureStream();
          }

          if (localAudioStream) {
            this.users.forEach((user) => {
              this.$set(
                  this.peers,
                  `audio-file-share-${user.id}`,
                  this.peerCreator(
                      localAudioStream,
                      user, false, false, false, true
                  )
              );
              this.peers[`audio-file-share-${user.id}`].create();
              this.peers[`audio-file-share-${user.id}`].initEvents();
            })
          }
        });
      })
    },
    cancelAudioSharing() {
      this.users.forEach((user) => {
        this.peers[`audio-file-share-${user.id}`].getPeer().destroy();
        delete this.peers[`audio-file-share-${user.id}`];
      })
      this.audioFileIsSharing = false
      this.audioFileSharer = null
      this.$refs["audioFileCard"].$refs["audio-file"].srcObject = null
    },

    async toggleRecord() {
      if (this.isRecording) {

        this.isRecording = false
        clearInterval(this.recordInterval)
        this.mediaRecorder.stop()

      } else {

        this.isRecording = true
        this.recordInterval = setInterval(() => {
          this.recordIcon = (this.recordIcon === 1 ? 2 : 1)
        }, 1000)

        const displayStream = await navigator.mediaDevices.getDisplayMedia({video: true, audio: true});
        const voiceStream = await navigator.mediaDevices.getUserMedia({audio: true, video: false});
        let tracks = [...displayStream.getTracks(), ...voiceStream.getAudioTracks()]
        const stream = new MediaStream(tracks);

        const mime = MediaRecorder.isTypeSupported("video/webm; codecs=vp9")
            ? "video/webm; codecs=vp9"
            : "video/webm"

        this.mediaRecorder = new MediaRecorder(stream, {
          mimeType: mime
        })

        let chunks = []
        this.mediaRecorder.addEventListener('dataavailable', function (e) {
          chunks.push(e.data)
        })

        let self = this
        this.mediaRecorder.addEventListener('stop', function () {
          let blob = new Blob(chunks, {
            type: chunks[0].type
          })
          let url = URL.createObjectURL(blob)

          let data = new FormData();
          data.append('file', blob);
          data.append('meeting_id', self.meeting_id);
          window.axios.post('/session/online-class/student/save-recorded-file', data)
              .then(() => {
              })
              .catch((err) => {
                console.log('Err Save Recorded File : ', err)
              })

          let a = document.createElement('a')
          a.href = url
          a.download = 'video.webm'
          a.click()
        })

        //we have to start the recorder manually
        this.mediaRecorder.start()
      }
    },

    endMeeting() {
      Object.entries(this.peers).forEach((peer) => {
        peer[1].getPeer().destroy();
      })
      this.Echo.leave("meeting." + this.meeting_id)
      this.Echo.leave(`meetingUser.${this.currentUser.id}`)
      this.errors = []
      this.showScore = true
    },

    toggleFullScreen(id) {
      let elem = document.getElementById(id)
      if (elem.style.position === 'absolute') {
        elem.style.position = 'relative'
        elem.style.zIndex = '0'
        elem.style.width = '100%'
        elem.style.height = '100%'
        this.fullscreenElement = null
      } else {
        elem.style.position = 'absolute'
        elem.style.width = '100vw'
        elem.style.height =
            window.innerHeight + 'px'
        elem.style.left = '0'
        elem.style.top = '0'
        elem.style.zIndex = '100'
        this.fullscreenElement = elem
      }
    },
    handlePageResize() {
      if (this.fullscreenElement) {
        this.fullscreenElement.style.height =
            window.innerHeight + 'px'
      }
    }
  },

  watch: {
    broadcasterIsInChannel: function (val) {
      if (val === false) {
        if (this.isRecording) {
          this.toggleRecord()
        }
        if (this.audioFileIsSharing) {
          this.cancelAudioSharing()
        }
        if (this.videoFileIsSharing) {
          this.cancelVideoSharing()
        }
        if (this.screenIsSharing) {
          this.toggleShareScreen()
        }
        if (this.whiteBoardStatus) {
          this.toggleWhiteBoard()
        }
        if (!this.mutedVideo) {
          this.toggleMuteVideo()
        }
        if (!this.mutedAudio) {
          this.toggleMuteAudio()
        }
      }
    },
  },

  beforeDestroy() {
    this.$refs.selfCard.$refs.self.srcObject.getVideoTracks()[0].stop()
    this.$refs.selfCard.$refs.self.srcObject.getAudioTracks()[0].stop()
    Object.entries(this.peers).forEach((peer) => {
      peer[1].getPeer().destroy();
    })
    this.Echo.leave("meeting." + this.meeting_id)
    this.Echo.leave(`meetingUser.${this.currentUser.id}`)
  }
}
</script>

<style scoped>
.bottom-buttons-group {
  position: fixed !important;
  bottom: 20px !important;
  width: 100%;
  text-align: left;
  left: 20px !important;
}

.fullscreen_center_box {
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  display: flex
}

.fullscreen_center_box_absolute {
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  display: flex;
  position: absolute;
  z-index: 99;
  background-color: #ffffff
}

.watermark {
  position: absolute;
  z-index: 99999;
  font-size: 20px;
  color: black;
  opacity: 0.30;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -webkit-touch-callout: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
  animation: 60s moving-watermark infinite;
  max-width: 100px;
}

@keyframes moving-watermark {
  0% {
    left: 5%;
    top: 5%;
  }
  15% {
    left: 85%;
    top: 5%;
  }
  30% {
    left: 42.5%;
    top: 42.5%;
  }
  50% {
    left: 85%;
    top: 85%;
  }
  65% {
    left: 5%;
    top: 85%;
  }
  80% {
    left: 42.5%;
    top: 42.5%;
  }
  100% {
    left: 5%;
    top: 5%;
  }
}
</style>